import React from 'react';
import { usePermissions } from '../../user/permissions';
import { Card, Message, Form, Select, TooltipHelp } from '@weezevent/nacre';
import { Trans, useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './organizerProfile.scss';
import Organization from '../../models/organization';

const legalStatusOptions = [
    { value: 'individual', text: <Trans i18nKey="ticket.organiser.description.legal_status_options_individual"> individual</Trans> },
    { value: 'company', text: <Trans i18nKey="ticket.organiser.description.legal_status_options_company"> company</Trans> },
    { value: 'association', text: <Trans i18nKey="ticket.organiser.description.legal_status_options_association">association</Trans> },
    { value: 'federation', text: <Trans i18nKey="ticket.organiser.description.legal_status_options_federation"> federation</Trans> },
    { value: 'groupment', text: <Trans i18nKey="ticket.organiser.description.legal_status_options_group">group</Trans> },
    { value: 'collectivity', text: <Trans i18nKey="ticket.organiser.description.legal_status_options_community">community </Trans> },
    { value: 'other', text: <Trans i18nKey="ticket.organiser.description.legal_status_options_other">other </Trans> }
];

export default function Description({ organization, formOrganisation, onChange, organisationErrors, errorHandler, organizationInfos }) {
    const { t } = useTranslation();
    const permissions = usePermissions();

    return (
        <Card.FormStep
            className="organizer-formstep-form"
            title={t(`ticket.organiser.description.title`)}
            rightComponent={
                <Message type="tips" title={t('ticket.organiser.description.tips')} mini>
                    <Trans i18nKey="ticket.organiser.description.infos.tips" />
                </Message>
            }
            id="organiser-form-description"
        >
            <>
                <Message title={t('ticket.organiser.description.legal_status_info.title')} type="default">
                    <p>{t('ticket.organiser.description.legal_status_info.description')}</p>
                </Message>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.description.formLabelName')} />
                    <Form.Input
                        errors={errorHandler('name')}
                        maxLength={80}
                        name="name"
                        placeholder={t('ticket.organiser.description.formPlaceholderName')}
                        value={formOrganisation.name}
                        onChange={({ target: { value } }) => {
                            onChange('name', value);
                        }}
                    />
                </Form.Field>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.description.legal_status')} />
                    <Select
                        errors={errorHandler('organization_type')}
                        clearable
                        placeholder={t('ticket.common.action.select')}
                        style={{ width: '100%' }}
                        search
                        disabled={!permissions.hasCapacity('PyvarCapacity.ADMIN') && organizationInfos.already_sold_web && Boolean(organization.organization_type)}
                        options={legalStatusOptions}
                        onChange={(synth, { value }) => {
                            onChange('organization_type', value);
                        }}
                        value={formOrganisation.organization_type}
                    />
                </Form.Field>
                <Form.Field>
                    <Form.Label optionalText={t('ticket.common.labelOptional')}>
                        {t('ticket.organiser.description.licence_number')}
                        <TooltipHelp title={t('ticket.organiser.description.tooltip_licence_number')} />
                    </Form.Label>
                    <Form.Input
                        errors={errorHandler('license_number')}
                        maxLength={50}
                        name="licence_number"
                        value={formOrganisation.license_number}
                        onChange={({ target: { value } }) => {
                            onChange('license_number', value);
                        }}
                    />
                </Form.Field>

                <Form.Field>
                    <Form.Label
                        label={t('ticket.organiser.description.eu_vat_number')}
                        optionalText={organization.business_entity.uuid !== Organization.BUSINESS_ENTITY_SPAIN && t('ticket.common.labelOptional')}
                    />
                    <Form.Input
                        errors={errorHandler('intra_community_vat')}
                        maxLength={80}
                        name="eu_vat_number"
                        value={formOrganisation.intra_community_vat}
                        onChange={({ target: { value } }) => {
                            onChange('intra_community_vat', value);
                        }}
                    />
                </Form.Field>
            </>
        </Card.FormStep>
    );
}
Description.propTypes = {
    formOrganisation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};
